export const contactsData = {
    email: 'ramkimarichamy9@gmail.com',
    phone: '+91 9578826468',
    address: '89, kattabomman street, Avarampatti, Rajapalayam, Tamilnadu',
    sheetAPI: 'https://sheetdb.io/api/v1/hmpljn7sx1w0w'
}